import { message } from 'antd';
import * as ACTIONS from 'app/actions/UserSearchActions';

const initialState = {
    //Internal
    isLoadingInternalEmployeesNames: false,
    listInternalEmployeesNames: [],
    isLoadingSubdirection: false,
    listInternalEmployeesSubdirection: [],
    isLoadingCategory: false,
    listInternalEmployeesCategory: [],
    isLoadingEmployeeId: false,
    listInternalEmployeesId: [],
    isLoadingEmployeeCompany: false,
    listInternalEmployeesCompany: [],
    isLoadingContract: false,
    listInternalEmployeesContract: [],
    isLoadingOT: false,
    listInternalEmployeesOT: [],
    isLoadingInternalEmail: false,
    listInternalEmployeesEmail: [],
    isLoadingInternalEmployees: false,
    listInternalEmployees: [],
    isLoadingIECeco: false,
    listInternalEmployeesCeco: [],
    isLoadingIEEpep: false,
    listInternalEmployeesEpep: [],
    isLoadingPernocta: false,
    listPercnota: [],
    isLoadingComunicationProgram: false,
    listComunicationProgram: [],
    isLoadingCourses: false,
    listCourses: [],
    //External
    isLoadingExternalEmployeesNames: false,
    listExternalEmployeesNames: [],
    isLoadingExternalEmail: false,
    listExternalEmployeesEmail: [],
    isLoadingExternalEmployees: false,
    listExternalEmployees: [],

    //Internal
    filter: {
        listInternalEmployeesNames: [],
        listInternalEmployeesSubdirection: [],
        listInternalEmployeesCategory: [],
        listInternalEmployeesId: [],
        listInternalEmployeesCompany: [],
        listInternalEmployeesContract: [],
        listInternalEmployeesOT: [],
        listInternalEmployeesEmail: [],
        listInternalEmployeesCeco: [],
        listInternalEmployeesEpep: [],
        listIsActive: [],
        listPercnota: [],
        listComunicationProgram: [],
        listCourses: [],

    },
    //External
    filterExternal: {
        listExternalEmployeesNames: [],
        listExternalEmployeesEmail: []
    },

    //Internal
    pagination: {
        current: 1,
        pageSize: 25,
        total: 0,
        column: '',
        order: ''
    },
    //External
    paginationExternal: {
        current: 1,
        pageSize: 25,
        total: 0,
        column: '',
        order: ''
    },

    //Internal
    isExportingXls: false,
    //External
    isExportingExternalXls: false,

    //Kardex
    isLoadingKardex: false,
    listKardex: [],
    isExportingKardexXls: false,
    isExportingBookmarkXls: false,
    isExportingKardexBookmarkXls: false
}

export const UserSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        //Obtiene el filtro de courses
        case ACTIONS.GET_INTERNAL_COMUNICATIONPROGRAM_REQUEST:
            return {
                ...state,
                isLoadingComunicationProgram: true
            }
        case ACTIONS.GET_INTERNAL_COMUNICATIONPROGRAM_SUCCESS:
            return {
                ...state,
                isLoadingComunicationProgram: false,
                listComunicationProgram: action.payload
            }
        case ACTIONS.GET_INTERNAL_COMUNICATIONPROGRAM_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingComunicationProgram: false
            }
        //Obtiene el filtro de courses
        case ACTIONS.GET_INTERNAL_COURSE_REQUEST:
            return {
                ...state,
                isLoadingCourses: true
            }
        case ACTIONS.GET_INTERNAL_COURSE_SUCCESS:
            return {
                ...state,
                isLoadingCourses: false,
                listCourses: action.payload
            }
        case ACTIONS.GET_INTERNAL_COURSE_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingCourses: false
            }
        //Obtiene el filtro de pernoctas
        case ACTIONS.GET_INTERNAL_PERNOCTA_REQUEST:
            return {
                ...state,
                isLoadingPernocta: true
            }
        case ACTIONS.GET_INTERNAL_PERNOCTA_SUCCESS:
            return {
                ...state,
                isLoadingPernocta: false,
                listPercnota: action.payload
            }
        case ACTIONS.GET_INTERNAL_PERNOCTA_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingPernocta: false
            }
        //Obtiene el combo nombres de empleados internos
        case ACTIONS.GET_INTERNAL_EMPLOYEE_NAMES_REQUEST:
            return {
                ...state,
                isLoadingInternalEmployeesNames: true
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_NAMES_SUCCESS:
            return {
                ...state,
                isLoadingInternalEmployeesNames: false,
                listInternalEmployeesNames: action.payload
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_NAMES_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingInternalEmployeesNames: false
            }
        //Obtiene el combo subdirecciones de empleados internos
        case ACTIONS.GET_INTERNAL_EMPLOYEE_SUBDIRECTION_REQUEST:
            return {
                ...state,
                isLoadingSubdirection: true
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_SUBDIRECTION_SUCCESS:
            return {
                ...state,
                isLoadingSubdirection: false,
                listInternalEmployeesSubdirection: action.payload
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_SUBDIRECTION_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingSubdirection: false
            }
        //Obtiene el combo fichas de empleados internos
        case ACTIONS.GET_INTERNAL_EMPLOYEE_ID_REQUEST:
            return {
                ...state,
                isLoadingEmployeeId: true
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_ID_SUCCESS:
            return {
                ...state,
                isLoadingEmployeeId: false,
                listInternalEmployeesId: action.payload
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_ID_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingEmployeeId: false
            }
        //Obtiene el combo compañia de empleados internos
        case ACTIONS.GET_INTERNAL_EMPLOYEE_COMPANY_REQUEST:
            return {
                ...state,
                isLoadingEmployeeCompany: true
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_COMPANY_SUCCESS:
            return {
                ...state,
                isLoadingEmployeeCompany: false,
                listInternalEmployeesCompany: action.payload
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_COMPANY_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingEmployeeCompany: false
            }
        //Obtiene el combo puesto de empleados internos
        case ACTIONS.GET_INTERNAL_EMPLOYEE_CATEGORY_REQUEST:
            return {
                ...state,
                isLoadingCategory: true
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_CATEGORY_SUCCESS:
            return {
                ...state,
                isLoadingCategory: false,
                listInternalEmployeesCategory: action.payload
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_CATEGORY_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingCategory: false
            }
        //Obtiene el combo contrato de empleados internos
        case ACTIONS.GET_INTERNAL_EMPLOYEE_CONTRACT_REQUEST:
            return {
                ...state,
                isLoadingContract: true
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_CONTRACT_SUCCESS:
            return {
                ...state,
                isLoadingContract: false,
                listInternalEmployeesContract: action.payload
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_CONTRACT_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingContract: false
            }
        //Obtiene el combo contrato de empleados internos
        case ACTIONS.GET_INTERNAL_EMPLOYEE_OT_REQUEST:
            return {
                ...state,
                isLoadingOT: true
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_OT_SUCCESS:
            return {
                ...state,
                isLoadingOT: false,
                listInternalEmployeesOT: action.payload
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_OT_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingOT: false
            }
        //Obtiene el combo email de empleados internos
        case ACTIONS.GET_INTERNAL_EMPLOYEE_EMAIL_REQUEST:
            return {
                ...state,
                isLoadingInternalEmail: true
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_EMAIL_SUCCESS:
            return {
                ...state,
                isLoadingInternalEmail: false,
                listInternalEmployeesEmail: action.payload
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_EMAIL_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingInternalEmail: false
            }
        //Obtiene el combo CECO de empleados internos
        case ACTIONS.GET_INTERNAL_EMPLOYEE_CECO_REQUEST:
            return {
                ...state,
                isLoadingIECeco: true
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_CECO_SUCCESS:
            return {
                ...state,
                isLoadingIECeco: false,
                listInternalEmployeesCeco: action.payload
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_CECO_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingIECeco: false
            }
        //Obtiene el combo EPEP de empleados internos
        case ACTIONS.GET_INTERNAL_EMPLOYEE_EPEP_REQUEST:
            return {
                ...state,
                isLoadingIEEpep: true
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_EPEP_SUCCESS:
            return {
                ...state,
                isLoadingIEEpep: false,
                listInternalEmployeesEpep: action.payload
            }
        case ACTIONS.GET_INTERNAL_EMPLOYEE_EPEP_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingIEEpep: false
            }
        //Obtiene datos de tabla de empleados internos
        case ACTIONS.FETCH_INTERNAL_EMPLOYEE_REQUEST:
            return {
                ...state,
                isLoadingInternalEmployees: true
            }
        case ACTIONS.FETCH_INTERNAL_EMPLOYEE_SUCCESS:
            return {
                ...state,
                isLoadingInternalEmployees: false,
                listInternalEmployees: action.payload,
                pagination: {
                    ...state.pagination,
                    total: action.payload.length > 0 ? action.payload[0].totalCount : 0,
                }
            }
        case ACTIONS.FETCH_INTERNAL_EMPLOYEE_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingInternalEmployees: false
            }
        //Obtiene datos para exportar tabla de empleados internos
        case ACTIONS.EXPORT_INTERNAL_EMPLOYEE_REQUEST:
            return {
                ...state,
                isExportingXls: true
            }
        case ACTIONS.EXPORT_INTERNAL_EMPLOYEE_SUCCESS:
            return {
                ...state,
                isExportingXls: false
            }
        case ACTIONS.EXPORT_INTERNAL_EMPLOYEE_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isExportingXls: false
            }
        //Obtiene el combo nombres de empleados externos
        case ACTIONS.GET_EXTERNAL_EMPLOYEE_NAMES_REQUEST:
            return {
                ...state,
                isLoadingExternalEmployeesNames: true
            }
        case ACTIONS.GET_EXTERNAL_EMPLOYEE_NAMES_SUCCESS:
            return {
                ...state,
                isLoadingExternalEmployeesNames: false,
                listExternalEmployeesNames: action.payload
            }
        case ACTIONS.GET_EXTERNAL_EMPLOYEE_NAMES_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingExternalEmployeesNames: false
            }
        //Obtiene el combo email de empleados externos
        case ACTIONS.GET_EXTERNAL_EMPLOYEE_EMAIL_REQUEST:
            return {
                ...state,
                isLoadingExternalEmail: true
            }
        case ACTIONS.GET_EXTERNAL_EMPLOYEE_EMAIL_SUCCESS:
            return {
                ...state,
                isLoadingExternalEmail: false,
                listExternalEmployeesEmail: action.payload
            }
        case ACTIONS.GET_EXTERNAL_EMPLOYEE_EMAIL_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingExternalEmail: false
            }
        //Obtiene datos de tabla de empleados externos
        case ACTIONS.FETCH_EXTERNAL_EMPLOYEE_REQUEST:
            return {
                ...state,
                isLoadingExternalEmployees: true
            }
        case ACTIONS.FETCH_EXTERNAL_EMPLOYEE_SUCCESS:
            return {
                ...state,
                isLoadingExternalEmployees: false,
                listExternalEmployees: action.payload,
                paginationExternal: {
                    ...state.paginationExternal,
                    total: action.payload.length > 0 ? action.payload[0].totalCount : 0,
                }
            }
        case ACTIONS.FETCH_EXTERNAL_EMPLOYEE_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingExternalEmployees: false
            }
        //Obtiene datos para exportar tabla de empleados internos
        case ACTIONS.EXPORT_EXTERNAL_EMPLOYEE_REQUEST:
            return {
                ...state,
                isExportingExternalXls: true
            }
        case ACTIONS.EXPORT_EXTERNAL_EMPLOYEE_SUCCESS:
            return {
                ...state,
                isExportingExternalXls: false
            }
        case ACTIONS.EXPORT_EXTERNAL_EMPLOYEE_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isExportingExternalXls: false
            }
        //Guarda los filtros
        case ACTIONS.SAVE_FILTER:

            return {
                ...state,
                filter: action.payload
            }
        //Obtiene datos del Kardex
        case ACTIONS.FETCH_KARDEX_REQUEST:
            return {
                ...state,
                isLoadingKardex: true
            }
        case ACTIONS.FETCH_KARDEX_SUCCESS:
            return {
                ...state,
                isLoadingKardex: false,
                listKardex: action.payload
            }
        case ACTIONS.FETCH_KARDEX_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isLoadingKardex: false
            }
        //Obtiene datos para exportar del kardex
        case ACTIONS.EXPORT_KARDEX_REQUEST:
            return {
                ...state,
                isExportingKardexXls: true
            }
        case ACTIONS.EXPORT_KARDEX_SUCCESS:
            return {
                ...state,
                isExportingKardexXls: false
            }
        case ACTIONS.EXPORT_KARDEX_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isExportingKardexXls: false
            }
        //Obtiene datos para exportar el bookmark
        case ACTIONS.EXPORT_BOOKMARK_EMPLOYEE_REQUEST:
            return {
                ...state,
                isExportingBookmarkXls: true
            }
        case ACTIONS.EXPORT_BOOKMARK_EMPLOYEE_SUCCESS:
            return {
                ...state,
                isExportingBookmarkXls: false
            }
        case ACTIONS.EXPORT_BOOKMARK_EMPLOYEE_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isExportingBookmarkXls: false
            }
        //Obtiene datos para exportar el kardex bookmark
        case ACTIONS.EXPORT_KARDEX_EMPLOYEE_REQUEST:
            return {
                ...state,
                isExportingKardexBookmarkXls: true
            }
        case ACTIONS.EXPORT_KARDEX_EMPLOYEE_SUCCESS:
            return {
                ...state,
                isExportingKardexBookmarkXls: false
            }
        case ACTIONS.EXPORT_KARDEX_EMPLOYEE_FAILURE:
            message.error(`Error: ${action.payload}`);
            return {
                ...state,
                isExportingKardexBookmarkXls: false
            }
        //Guarda los filtros
        case ACTIONS.SAVE_FILTER:
            return {
                ...state,
                filter: action.payload
            }
        //Guarda los filtros Externos
        case ACTIONS.SAVE_FILTER_EXTERNAL:
            return {
                ...state,
                filterExternal: action.payload
            }
        //Guarda el paginador
        case ACTIONS.SAVE_PAGINATION:
            return {
                ...state,
                pagination: action.payload
            }

        //Guarda el paginador externo
        case ACTIONS.SAVE_PAGINATION_EXTERNAL:
            return {
                ...state,
                paginationExternal: action.payload
            }

        //Limpia el reducer
        case ACTIONS.CLEAR_REDUCER:
            return initialState;
        default:
            return state;
    }
}